export default class designSectionMobile {
	constructor() {
		this._init();
	}

	_init() {
		let MobileMenuElements = document.querySelectorAll(
			'.design-section-mobilenav__toggle-button'
		);
		for (let i = 0; i < MobileMenuElements.length; i++) {
			let element = MobileMenuElements[i];
			element.addEventListener('click', function(evt) {
				evt.preventDefault();
				this.parentElement.classList.toggle('opened');
				this.nextElementSibling.classList.toggle('ul-twolvl-opened');
			});
		}

		document
			.querySelector('.designsecion-hamburger')
			.addEventListener('click', function(evt) {
				evt.preventDefault();

				document.querySelector('.design-section').classList.toggle('no-scroll');

				this.classList.toggle('opened');

				var isOpen = this.getAttribute('aria-expanded');
				if (isOpen === 'true') {
					isOpen = false;
				} else {
					isOpen = true;
				}
				this.setAttribute('aria-expanded', isOpen);

				this.getAttribute('aria-expanded');
				document
					.querySelector('.design-section-mobilenav__opened')
					.classList.toggle('hamburger-opened');
			});
	}
}
